"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneTimeToJSON = exports.PhoneTimeFromJSONTyped = exports.PhoneTimeFromJSON = exports.PhoneTime = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var PhoneTime;
(function (PhoneTime) {
    PhoneTime["MORNING"] = "MORNING";
    PhoneTime["AFTERNOON"] = "AFTERNOON";
    PhoneTime["EVENING"] = "EVENING";
    PhoneTime["ALWAYS"] = "ALWAYS";
})(PhoneTime = exports.PhoneTime || (exports.PhoneTime = {}));
function PhoneTimeFromJSON(json) {
    return PhoneTimeFromJSONTyped(json, false);
}
exports.PhoneTimeFromJSON = PhoneTimeFromJSON;
function PhoneTimeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PhoneTimeFromJSONTyped = PhoneTimeFromJSONTyped;
function PhoneTimeToJSON(value) {
    return value;
}
exports.PhoneTimeToJSON = PhoneTimeToJSON;
//# sourceMappingURL=PhoneTime.js.map